import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { setServices } from '../Store/serviceSlice';
import useApi from '../useApis';
import useClinic from './useClinic';
const useDoctor = () => {
  const dispatch = useDispatch();
  const clinicFees = useSelector((state) => state?.authReducer?.doctorOpdFees);
  const { getAllPatientsQueue, getPatientQueueChecked } = useClinic();
  const [serviceList, setServiceList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const [medicines, setMedicines] = useState([]);
  const [dashboard, setDashboard] = useState(null);
  const [testAndAddOnsLoading, setTestAndAddOnsLoading] = useState({
    labTest: false,
    radioLogyTest: false,
    drugAllergy: false,
    longTermCondition: false,
    previousService: false,
    previousMedication: false,
    vitals: false,
    symptoms: false,
    diagnosis: false,
    test: false,
    radio: false
  });
  const [tests, setTests] = useState([]);
  const api = useApi();

  //This api provides listing of Patients
  const getAllServicesListing = async () => {
    setLoading(true);
    const response = await api?.getServices();
    if (response?.data?.headers?.code === 200) {
      //for append all services
      dispatch(
        setServices([
          { serviceId: null, serviceFees: clinicFees, serviceName: 'OPD' },
          ...response?.data?.body?.map((data) => ({ ...data, quantity: 0 }))
        ])
      );
      setServiceList([...response?.data?.body]);
      setLoading(false);
      return response?.data?.body; // Directly return the data as well
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
    return null;
  };
  const addOrEditServiceSubmit = async (params, resetForm) => {
    setLoading(true);
    const response = await api?.addOrEditService({ ...params });
    if (response?.data?.headers?.code === 200) {
      const services = await getAllServicesListing(1, '');
      if (services) setServiceList([...services]);
      toast.success(
        params?.serviceId ? 'Service updated successfully' : 'Service created successfully'
      );
      resetForm();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const deleteServiceSubmit = async (params, resetForm) => {
    setLoading(true);
    const response = await api?.deleteService(params);
    if (response?.data?.headers?.code == 200) {
      getAllServicesListing();
      if (typeof resetForm === 'function') {
        resetForm();
      }
    }
    setLoading(false);
  };
  const doctorSendNextPatient = async (params, onCancel) => {
    setLoading(true);
    const response = await api.doctorSendNextPatient(params);
    if (response?.data?.headers?.code === 200) {
      getAllPatientsQueue();
      getPatientQueueChecked();
      if (typeof onCancel == 'function') onCancel();
      // toast.success(response?.data?.headers?.msg);
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };

  const addDrugAllergies = async (params) => {
    setTestAndAddOnsLoading((prev) => ({ ...prev, drugAllergy: true }));
    const response = await api.addDrugAllergies(params);
    if (response?.data?.headers?.code === 200) {
      toast.success("Drug'(s) allergy added successfully");
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setTestAndAddOnsLoading((prev) => ({ ...prev, drugAllergy: false }));
  };

  const longTermCondition = async (params) => {
    setTestAndAddOnsLoading((prev) => ({ ...prev, longTermCondition: true }));
    const response = await api.longtermConditions(params);
    if (response?.data?.headers?.code === 200) {
      toast.success('Long Term(s) Condition added successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setTestAndAddOnsLoading((prev) => ({ ...prev, longTermCondition: false }));
  };
  const addPreviousService = async (params) => {
    setTestAndAddOnsLoading((prev) => ({ ...prev, previousService: true }));
    const response = await api.addPreviousService(params);
    if (response?.data?.headers?.code === 200) {
      toast.success('Service(s) added successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setTestAndAddOnsLoading((prev) => ({ ...prev, previousService: false }));
  };
  const addDisability = async (params) => {
    setTestAndAddOnsLoading((prev) => ({ ...prev, disability: true }));
    const response = await api.addDisability(params);
    if (response?.data?.headers?.code === 200) {
      toast.success('Disability added successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setTestAndAddOnsLoading((prev) => ({ ...prev, disability: false }));
  };

  const addPreviousMedication = async (params) => {
    setTestAndAddOnsLoading((prev) => ({ ...prev, previousMedication: true }));
    const response = await api.addPreviousMedication(params);
    if (response?.data?.headers?.code === 200) {
      toast.success('Medication added successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setTestAndAddOnsLoading((prev) => ({ ...prev, previousMedication: false }));
  };

  const addSymptoms = async (params, onCancel) => {
    setTestAndAddOnsLoading((prev) => ({ ...prev, symptoms: true }));
    const response = await api.addSymptoms(params);
    if (response?.data?.headers?.code === 200) {
      if (typeof onCancel === 'function') onCancel();
      toast.success('Symptoms added successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setTestAndAddOnsLoading((prev) => ({ ...prev, symptoms: false }));
  };

  const addVitals = async (params, onCancel) => {
    setTestAndAddOnsLoading((prev) => ({ ...prev, vitals: true }));
    const response = await api.addVitals(params);
    if (response?.data?.headers?.code === 200) {
      if (typeof onCancel === 'function') onCancel();

      toast.success('Vital added successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setTestAndAddOnsLoading((prev) => ({ ...prev, vitals: false }));
  };

  const addDiagnosis = async (params, onCancel) => {
    setTestAndAddOnsLoading((prev) => ({ ...prev, diagnosis: true }));
    const response = await api.addDiagnosis(params);
    if (response?.data?.headers?.code === 200) {
      if (typeof onCancel === 'function') onCancel();
      toast.success('Diagnosis added successfully');
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setTestAndAddOnsLoading((prev) => ({ ...prev, diagnosis: false }));
  };
  const getAllMedicines = async (params, onCancel) => {
    setLoading(true);
    const response = await api.getAllMedicines(params);
    if (response?.data?.headers?.code === 200) {
      setMedicines(response?.data?.body?.data?.medicines);
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const getTest = async (params, onCancel) => {
    setLoading(true);
    const response = await api.getTest(params);
    if (response?.data?.headers?.code === 200) {
      const transformedData = response?.data?.body?.map(({ testId, testName, ...res }) => ({
        label: testName,
        value: testId,
        ...res
      }));
      setTests(transformedData);
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };

  const addTest = async (params, onCancel) => {
    setTestAndAddOnsLoading((prev) => ({ ...prev, test: true }));
    const response = await api.addTest(params);
    if (response?.data?.headers?.code === 200) {
      onCancel();
      toast.success('Test Added Successfully');
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg);
    }

    setTestAndAddOnsLoading((prev) => ({ ...prev, test: false }));
  };

  const addPrescription = async (params, onCancel) => {
    const response = await api.addPrescription(params);
    if (response?.data?.headers?.code === 200) {
      onCancel();
      toast.success('Prescription Added Successfully');
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
  };

  const requestNextPatient = async (params, onCancel) => {
    setLoading(true);
    // setTestAndAddOnsLoading((prev) => ({ ...prev, radio: true }));
    const response = await api.requestNextPatient(params);
    if (response?.data?.headers?.code === 200) {
      getAllPatientsQueue();
      getPatientQueueChecked();
      if (typeof onCancel === 'function') onCancel();

      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
    // setTestAndAddOnsLoading((prev) => ({ ...prev, radio: false }));
  };
  //handle fee
  const editRequestPatient = async (params, onCancel) => {
    setLoading(true);
    const response = await api.editRequestPatient(params);
    if (response?.data?.headers?.code === 200) {
      toast.success('Patient Fee Updated Successfully');
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };
  const getDoctorDashboard = async (params, onCancel) => {
    setLoading(true);
    const response = await api?.getDoctorDashboard(params);
    if (response?.data?.headers?.code === 200) {
      setDashboard(response?.data?.body);
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };

  const addDoctorNotes = async (params, onCancel) => {
    setLoading(true);
    // setTestAndAddOnsLoading((prev) => ({ ...prev, radio: true }));
    const response = await api.addDoctorNotes(params);
    if (response?.data?.headers?.code === 200) {
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
    // setTestAndAddOnsLoading((prev) => ({ ...prev, radio: false }));
  };

  return {
    loading,
    serviceList,
    setPage,
    page,
    setSearch,
    search,
    getAllServicesListing,
    addOrEditServiceSubmit,
    deleteServiceSubmit,
    doctorSendNextPatient,
    getAllMedicines,
    medicines,
    addDrugAllergies,
    longTermCondition,
    addPreviousService,
    addDisability,
    addPreviousMedication,
    addSymptoms,
    addVitals,
    addDiagnosis,
    getTest,
    tests,
    addTest,
    requestNextPatient,
    editRequestPatient,
    loading,
    testAndAddOnsLoading,
    dashboard,
    getDoctorDashboard,
    addDoctorNotes,
    addPrescription
  };
};

export default useDoctor;
